import { Box, Button, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import { ReactComponent as BalootLogo } from "../../../assets/icons/logo-white.svg";
import { ReactComponent as CheckBoxIcon } from "../../../assets/icons/checkbox.svg";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import CustomTextSkeleton from "../../../components/shared/CustomTextSkeleton";
import { BalootUserAPIs } from "../../../api/APIs";
import { useRequest } from "../../../api/utils/useRequest";
import React, { useEffect, useState, useRef } from "react";
import CircularProgress, {
  circularProgressClasses,
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import moment from "moment-jalaali";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import CustomRectangularSkeleton from "../../../components/shared/CustomRectangularSkeleton";

function ProfileAccountPage() {
  const navigate = useNavigate();
  const {
    loading,
    apiCall: getAccountStep,
    result,
  } = useRequest(BalootUserAPIs.accountSetupStep);
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    getAccountStep({
      onSuccess: (res) => {
        setPercent(() => res.percent);
      },
    });
  }, []);

  const goTo = (actionName) => {
    switch (actionName) {
      case "NAVIGATE_TO_AUTO_SAVING":
        navigate("/app/direct-debit");
        break;
      case "NAVIGATE_TO_AUTO_INVESTMENT":
        navigate("/app/auto-investment");
        break;
      case "NAVIGATE_TO_ASSET_LIST":
        navigate("/app/navigation/investment");
        break;
      case "NAVIGATE_TO_SEJAM_AUTHENTICATION":
        navigate("/app/profile/setting/sejam/status");
        break;
      case "NAVIGATE_TO_WALLET_ACTIVATION":
        navigate("/app/profile/setting/personal");
        break;
    }
  };
  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
      />

      <Box
        sx={{
          overflow: "auto",
          flex: 1,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Box>
          <Box
            sx={{
              width: "100%",
              px: "24px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                position: "relative",
                p: 2,
                mt: 1,
              }}
            >
              <BalootLogo width={56} height={74} />
              <CircularProgress
                variant="determinate"
                sx={{
                  color: "common.white",
                  opacity: "0.3",
                  position: "absolute",
                  top: -1,
                  left: -13,
                  zIndex: 1,
                }}
                size={115}
                thickness={3}
                value={100}
              />
              <CircularProgress
                variant="determinate"
                size={115}
                value={percent}
                thickness={3}
                sx={{
                  color: "common.white",
                  position: "absolute",
                  top: -1,
                  left: -13,
                  zIndex: 2,
                  [`& .${circularProgressClasses.circle}`]: {
                    strokeLinecap: "round",
                  },
                }}
              />
            </Box>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {loading ? (
                <>
                  <CustomTextSkeleton width={100} />
                  <CustomTextSkeleton width={50} />
                </>
              ) : (
                <>
                  <Typography
                    variant="h4"
                    color="common.white"
                    sx={{ opacity: 0.9 }}
                  >
                    {percent}%
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="common.white"
                    sx={{ mt: 1 }}
                    align="center"
                  >
                    با تکمیل بخش‌های زیر به یک سرمایه‌گذار موفق در بلوط تبدیل
                    شوید
                  </Typography>
                  <Box
                    sx={{
                      mt: 2,
                      pt: 1,
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderTop: `1px solid white`,
                    }}
                  >
                    <Typography variant="h5" color="common.white">
                      {result?.userName}
                    </Typography>
                    <Typography variant="subtitle1" color="common.white">
                      {`سرمایه‌گذار از: ${moment(
                        result?.investmentStartDate
                      ).format("jYYYY/jMM/jDD")}`}
                    </Typography>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>
        <PageContentContainer sx={{ overflow: "auto", display: "block" }}>
          {loading ? (
            <>
              <CustomRectangularSkeleton height={80} />
              <CustomRectangularSkeleton height={80} sx={{ my: 1 }} />
              <CustomRectangularSkeleton height={80} sx={{ my: 1 }} />
              <CustomRectangularSkeleton height={80} sx={{ my: 1 }} />
            </>
          ) : (
            result?.list.map((item) => {
              return (
                <React.Fragment key={item.step.id}>
                  {item.done ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mt: 2.5,
                        mb: 3.5,
                      }}
                    >
                      <CheckBoxIcon width={24} height={24} />

                      <Typography ml={1} variant={"body2"} color={"grey.2"}>
                        {item.step.title}
                      </Typography>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "space-between",
                        py: "16px",
                        px: "12px",
                        mb: 1.5,
                        boxShadow: (theme) => theme.shadows[2],
                        bgcolor: "common.white",
                        borderRadius: "8px",
                      }}
                      onClick={() => goTo(item.step.mobileAction)}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          flexDirection: "column",
                        }}
                      >
                        <Typography variant={"body2"} color={"grey.2"} mr={1}>
                          {item.step.title}
                        </Typography>

                        <Typography
                          fontSize={"10px"}
                          variant={"subtitle1"}
                          color={"grey.9"}
                          mr={1}
                          mt={0.5}
                        >
                          {item.step.subtitle}
                        </Typography>
                      </Box>

                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <KeyboardArrowLeftIcon
                          sx={{ color: "primary.main", height: 20 }}
                        />
                      </Box>
                    </Box>
                  )}
                </React.Fragment>
              );
            })
          )}
        </PageContentContainer>
      </Box>
    </>
  );
}

export default ProfileAccountPage;
